module.exports = __webpack_public_path__ + "static/img/8.10505241.png";